import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"
const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const sendOptToDeleteAppAction = createAsyncThunk(
    'send-otp-to-delete-app',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/send-otp-to-delete-app`, data )
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const sendotpToDeleteAppSlice = createSlice({
    name: 'send-otp-to-delete-app',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(sendOptToDeleteAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(sendOptToDeleteAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(sendOptToDeleteAppAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const sendOtpToDeleteAppReducer = sendotpToDeleteAppSlice.reducer